export function createHashClickHandler(locale: string, pathname: string, id: string) {
  return (e: MouseEvent) => {
    try {
      if (pathname === `/${locale}` || pathname === `/${locale}/`) {
        e.preventDefault()
        const el = document.getElementById(id)
        el?.scrollIntoView({ behavior: 'smooth' })
      }
    } catch (err) {
      // swallow any errors to avoid breaking UI
      // eslint-disable-next-line no-console
      console.warn('scroll-to-hash failed', err)
    }
  }
}
